export const FilterList = [
    {
        title: 'recently',
        name: {
            'fa': 'جدیدترین'
        },
    },
    // {
    //     title: 'rate',
    //     name: {
    //         'fa': 'محبوب ترین'
    //     },
    // },
    // {
    //     title: 'active',
    //     name: {
    //         'fa': 'فعال ترین'
    //     },
    // },
    {
        title: 'highest price',
        name: {
            'fa': 'بیشترین قیمت'
        },
    },
    {
        title: 'lowest price',
        name: {
            'fa': 'کمترین قیمت'
        },
    },
]
export const SearchCategory = [
    {
        value: 'sort',
        name: 'مرتب سازی',
        hasSubCategory: true,
        subType: 'singleSelect',
        SubCategoryList: FilterList,
        show: false,
        active: false
    },
    {
        value: 'price',
        name: 'قیمت',
        show: false,
        active: false
    }
]